import React from "react";
import DashboardSummary from "./dashboardsummary";
import NotificationForm from "./notificationform";

function DashboardHome() {
    return (
        <div className="min-h-screen bg-gray-50 p-6">
            <h1 className="text-3xl font-bold mb-4">Welcome to the Admin Dashboard</h1>

            {/* Dashboard Summary */}
            <DashboardSummary />
            {<NotificationForm />}

            {/* Placeholder for Graphical Stats */}
            {/* <div className="mt-10 p-6 bg-white rounded-xl shadow-md">
                <h2 className="text-xl font-semibold mb-2">📈 Graphical Stats</h2>
                <div className="h-40 flex items-center justify-center text-gray-400">
                    Charts coming soon...
                </div>
            </div> */}
        </div>
    );
};

export default DashboardHome;
